import { makePxlStr } from '@aloft/toolkit-sui';
import { ChakraProps } from '@aloft/toolkit-sui/chakra';

import { SystemAccessorTPColumnKey, SystemDisplayTPColumnKey, TPColumnKey } from './types.js';

export const DEFAULT_COLUMNS: (TPColumnKey | SystemAccessorTPColumnKey)[] = [
  'address',
  'distance',
  'site',
  'grossLivingArea',
  'aboveGradeBedroomCount',
  'baths',
  'yearBuilt',
  'attachedGarageParkingSpacesCount',
  'closeDate',
  'salePrice',
  'listingStatus',
  'listingID',
];

export const IS_SELECTED_COLUMN_ID: SystemDisplayTPColumnKey = 'isSelected';

export const PLACEHOLDER = '-';

// Adding "padding" via `height` instead of `padding` makes it
// easier to compute the `top` position offset of the sticky rows
const HEADER_FAKE_PADDING_Y_IN_PX = 6;
export const HEADER_HEIGHT_IN_PX = 32 + HEADER_FAKE_PADDING_Y_IN_PX * 2;

export const PADDING_X_IN_PX = 12;
export const sharedCellStyles: ChakraProps = {
  textAlign: 'left',
  verticalAlign: 'middle',
  paddingX: makePxlStr(PADDING_X_IN_PX),
  whiteSpace: 'nowrap',
};

// This is the tanstack-table default column size. Unfortunately, we
// can't use a value such as `-Infinity`, `Infinity`, `NaN`, or
// `undefined` because tanstack-table will resize the column and change
// it under the hood.
export const UNSET_COLUMN_SIZE = 150;
